import { z } from 'zod';
import { isValidCnpj } from './cnpj';

/**
 * Slug regex — kept aligned with `core/backend/src/modules/company/interfaces/http/schemas.ts`
 * SlugRegex (`/^[a-z0-9-]+$/`). The Slug field's tooltip walks consultores
 * through the convention; backend re-validates with the same regex.
 */
export const SLUG_REGEX = /^[a-z0-9-]+$/;
export const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/;

/**
 * Helper text shown next to the Slug label via Tooltip. Externalized so the
 * Storybook "info-tooltip-focused" story can assert on the exact string.
 */
export const SLUG_HELPER_TEXT =
  'Use apenas letras minúsculas, números e hífens (sem acentos, espaços ou outros caracteres). Exemplo: Casas Bahia → casas-bahia.';

export const companyFormSchema = z.object({
  name: z.string().min(1, 'Informe o nome da empresa').max(200),
  cnpj: z
    .string()
    .min(1, 'Informe o CNPJ')
    // `isValidCnpj` enforces both the masked format and Receita Federal's
    // mod-11 check digits, so a single error message covers "wrong shape" +
    // "wrong digits" — the user sees the same hint regardless of which
    // failure mode they tripped.
    .refine(isValidCnpj, 'Informe um CNPJ válido (ex.: 00.000.000/0000-00)'),
  slug: z
    .string()
    .min(1, 'Informe o slug')
    .max(64)
    .regex(SLUG_REGEX, 'Use apenas letras minúsculas, números e hífens'),
  website: z.string().min(1, 'Informe o site').url('Informe um site válido'),
  primaryColor: z
    .string()
    .min(1, 'Informe a cor primária')
    .regex(HEX_COLOR_REGEX, 'Use o formato #RRGGBB'),
});

export type CompanyFormValues = z.infer<typeof companyFormSchema>;
